import i18nFactory from '@yandex-int/i18n';
import { ButtonPin } from 'lego-on-react';

import { FiltersValue, IndoorDictionary } from '../../../typings/displayMap';
import { filterType, selectedFilters as easySelectedFilters } from '../../EasyFilters/EasyFilters';

import * as keyset from './Indoor.i18n';

const i18n = i18nFactory(keyset);

export const IndoorUtils = {
    getFilters: (
        filtersValue: FiltersValue,
        selectedFilters: {
            [name: string]: easySelectedFilters;
        },
        dictionary: IndoorDictionary
    ) => {
        // TODO отделить changed от значения фильтров
        // TODO тайп для selectedFilters
        // TODO «Очистить»
        return [
            {
                name: 'facilityType',
                type: filterType.multiSelect,
                selected: selectedFilters.facilityType || [],
                items: filtersValue.facilityType.map((item: string) => ({
                    text: dictionary.facility[item],
                    val: item
                })),
                text: i18n('category'),
                button: {
                    pin: 'circle-circle' as ButtonPin
                },
                optionalPlaceHolder: true
            },
            {
                name: 'zoneCategory',
                type: filterType.multiSelect,
                selected: selectedFilters.zoneCategory || [],
                items: filtersValue.zoneCategory.map((item: string) => ({
                    text: dictionary.zone[item],
                    val: item
                })),
                text: i18n('zones'),
                button: {
                    pin: 'circle-circle' as ButtonPin
                },
                optionalPlaceHolder: true
            },
            {
                name: 'selected',
                type: filterType.boolean,
                selected: !!selectedFilters.selected,
                pin: 'circle-circle' as ButtonPin,
                text: i18n('selected')
            }
        ];
    }
};
